import { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import CoachChat from '../../components/coaches/CoachChat';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';

type ChatClient = { id: string; nombre: string; email: string };

export default function ChatPage() {
  const { profile } = useAuth();
  const [clients, setClients] = useState<ChatClient[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      if (!profile?.adminId) {
        setError('No se pudo identificar el perfil del coach.');
        setLoading(false);
        return;
      }
      setLoading(true);
      const { data, error: queryError } = await supabase.from('usuarios')
        .select('id,nombre,email').eq('profesor_admin_id', profile.adminId)
        .eq('estado', 'activo').order('nombre');
      if (queryError) setError(queryError.message);
      else { setClients((data || []) as ChatClient[]); setError(null); }
      setLoading(false);
    };
    void load();
  }, [profile?.adminId]);

  return <AdminLayout><main className="w-full h-full min-h-0">
    {loading ? <div className="bg-white border rounded-xl p-8 text-gray-500">Cargando conversaciones…</div>
      : error ? <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-4">{error}</div>
      : <CoachChat clients={clients} />}
  </main></AdminLayout>;
}
